import { type FC, type ReactNode } from "react";
import * as styles from "./styles.css";

type Props = {
  children: ReactNode;
  hasBorder?: boolean;
  hasBackgroundGradation?: boolean;
  className?: string;
};

export const RoundCassette: FC<Props> = ({
  children,
  className,
  hasBorder,
  hasBackgroundGradation,
}) => (
  <div className={`${styles.cassette({ hasBorder, hasBackgroundGradation })} ${className ?? ""}`}>
    {children}
  </div>
);
